import React, { useState } from 'react';
import viewDataStyles from './ViewDataTab.module.scss';
import * as XLSX from 'xlsx';

const ViewData = ({
  viewDataItems,
  viewDataLoading,
  viewDataForms,
  selectedFormForView,
  filters,
  currentPage,
  itemsPerPage,
  showFilters,
  handleFilterChange,
  clearAllFilters,
  getFilteredRows,
  getPaginatedRows,
  totalPages,
  handlePageChange,
  handleItemsPerPageChange,
  toggleFilters,
  setSelectedFormForView,
  setActiveTab
}) => {
  const filteredRows = getFilteredRows();
  const paginatedRows = getPaginatedRows();
  const [showFilterSection, setShowFilterSection] = useState(false);
  
  // Check if any filters are active
  const hasActiveFilters = Object.values(filters).some(value => value && value.trim() !== '');

  // Export to Excel function
  const exportToExcel = () => {
    try {
      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      
      // Create structured data array
      const structuredData = [];
      
      // Add title row
      structuredData.push(['सामानहरूको सारांश']);
      structuredData.push([]); // Empty row for spacing
      
      // Add main header row
      const mainHeaderRow = [
        'क्र.सं.',
        'खरिद आदेश / हस्तान्तरण फारम नं.',
        'जिन्सी वर्गीकरण संकेत नं.',
        'जिन्सी खाता पाना नं.',
        'सामानको नाम',
        'स्पेसिफिकेशन',
        'सामानको पहिचान नं.',
        'मोडल नं.',
        'मूल्य (बिल बिजक अनुसार)',
        'मूल्य (बिल बिजक अनुसार)',
        'मूल्य (बिल बिजक अनुसार)',
        'मूल्य (बिल बिजक अनुसार)',
        'मूल्य (बिल बिजक अनुसार)',
        'मूल्य (बिल बिजक अनुसार)',
        'अन्य खर्च',
        'अन्य खर्च समेत जम्मा रकम',
        'कैफियत'
      ];
      structuredData.push(mainHeaderRow);
      
      // Add sub-header row
      const subHeaderRow = [
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        'इकाई',
        'परिमाण',
        'दर',
        'जम्मा मु.अ.कर बाहेक',
        'मु.अ.कर',
        'सामानको जम्मा मूल्य',
        '',
        '',
        ''
      ];
      structuredData.push(subHeaderRow);
      
      // Add data rows
      filteredRows.forEach((row, index) => {
        const dataRow = [
          ((currentPage - 1) * itemsPerPage) + index + 1,
          row.purchase_order_number || 'N/A',
          row.classification_code || 'N/A',
          row.ledger_page_number || 'N/A',
          row.item_name || 'N/A',
          row.specification || 'N/A',
          row.item_identification_number || 'N/A',
          row.model_number || 'N/A',
          row.unit || 'N/A',
          row.quantity || 'N/A',
          row.rate || 'N/A',
          row.total_excluding_vat || 'N/A',
          row.vat || 'N/A',
          row.total_item_value || 'N/A',
          row.other_expenses || 'N/A',
          row.total_with_other_expenses || 'N/A',
          row.remarks || 'N/A'
        ];
        structuredData.push(dataRow);
      });
      
      // Create worksheet from structured data
      const worksheet = XLSX.utils.aoa_to_sheet(structuredData);
      
      // Set column widths
      const columnWidths = [
        { wch: 8 },   // क्र.सं.
        { wch: 25 },  // खरिद आदेश
        { wch: 20 },  // वर्गीकरण
        { wch: 15 },  // खाता पाना
        { wch: 25 },  // सामानको नाम
        { wch: 20 },  // स्पेसिफिकेशन
        { wch: 18 },  // पहिचान नं.
        { wch: 12 },  // मोडल नं.
        { wch: 10 },  // इकाई
        { wch: 12 },  // परिमाण
        { wch: 12 },  // दर
        { wch: 18 },  // जम्मा मु.अ.कर बाहेक
        { wch: 12 },  // मु.अ.कर
        { wch: 18 },  // सामानको जम्मा मूल्य
        { wch: 12 },  // अन्य खर्च
        { wch: 20 },  // अन्य खर्च समेत जम्मा रकम
        { wch: 15 }   // कैफियत
      ];
      worksheet['!cols'] = columnWidths;
      
      // Add cell merges for headers
      if (!worksheet['!merges']) worksheet['!merges'] = [];
      worksheet['!merges'].push({ s: { r: 2, c: 8 }, e: { r: 2, c: 13 } });
      
      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'सामानहरूको सारांश');
      
      // Generate filename with current date
      const now = new Date();
      const dateStr = now.toISOString().split('T')[0];
      const filename = `Form403_ViewData_Report_${dateStr}.xlsx`;
      
      // Save file
      XLSX.writeFile(workbook, filename);
      
      console.log('Excel file exported successfully:', filename);
      alert('Excel file exported successfully!');
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      alert('Error exporting to Excel. Please try again.');
    }
  };

  return (
    <div className={viewDataStyles.viewDataContainer}>
      <h2>फारम डाटा हेर्नुहोस्</h2>
      
      {/* Filter Toggle Button */}
      <div className={viewDataStyles.filterToggleContainer}>
        <button 
          onClick={() => setShowFilterSection(!showFilterSection)}
          className={`${viewDataStyles.filterToggleButton} ${hasActiveFilters ? viewDataStyles.activeFilters : ''}`}
        >
          {showFilterSection ? 'फिल्टर लुकाउनुहोस्' : 'फिल्टर देखाउनुहोस्'}
          {hasActiveFilters && <span className={viewDataStyles.activeFilterIndicator}>●</span>}
          <span className={viewDataStyles.filterToggleIcon}>
            {showFilterSection ? '▼' : '▶'}
          </span>
        </button>
      </div>
      
      {/* Filter Section */}
      {showFilterSection && (
        <div className={viewDataStyles.filterSection}>
          <div className={viewDataStyles.filterHeader}>
            <h3>फिल्टर सेटिङहरू</h3>
            <button 
              onClick={clearAllFilters}
              className={viewDataStyles.clearFiltersButton}
            >
              सबै फिल्टर सफा गर्नुहोस्
            </button>
          </div>
          
          {/* Form Level Filters */}
          <div className={viewDataStyles.filterCategory}>
            <h4>फारम स्तरका फिल्टरहरू</h4>
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>दाखिला मितिः</label>
                <input
                  type="text"
                  value={filters.admissionDate || ''}
                  onChange={(e) => handleFilterChange('admissionDate', e.target.value)}
                  placeholder="दाखिला मिति"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>दाखिला प्रतिवेदन नं.:</label>
                <input
                  type="text"
                  value={filters.admissionReportNumber || ''}
                  onChange={(e) => handleFilterChange('admissionReportNumber', e.target.value)}
                  placeholder="दाखिला प्रतिवेदन नं."
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>कार्यालय कोड नं.:</label>
                <input
                  type="text"
                  value={filters.officeCode || ''}
                  onChange={(e) => handleFilterChange('officeCode', e.target.value)}
                  placeholder="कार्यालय कोड नं."
                />
              </div>
            </div>
            
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>कार्यालय:</label>
                <input
                  type="text"
                  value={filters.officeName || ''}
                  onChange={(e) => handleFilterChange('officeName', e.target.value)}
                  placeholder="कार्यालय"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>कार्यालय ठेगाना:</label>
                <input
                  type="text"
                  value={filters.officeAddress || ''}
                  onChange={(e) => handleFilterChange('officeAddress', e.target.value)}
                  placeholder="कार्यालय ठेगाना"
                />
              </div>
            </div>
            
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>फाँटवालाको नाम:</label>
                <input
                  type="text"
                  value={filters.fontwalName || ''}
                  onChange={(e) => handleFilterChange('fontwalName', e.target.value)}
                  placeholder="फाँटवालाको नाम"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>भण्डार प्रमुखको नाम:</label>
                <input
                  type="text"
                  value={filters.branchHeadName || ''}
                  onChange={(e) => handleFilterChange('branchHeadName', e.target.value)}
                  placeholder="भण्डार प्रमुखको नाम"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>प्रमाणित गर्नेको नाम:</label>
                <input
                  type="text"
                  value={filters.officeHeadName || ''}
                  onChange={(e) => handleFilterChange('officeHeadName', e.target.value)}
                  placeholder="प्रमाणित गर्नेको नाम"
                />
              </div>
            </div>
          </div>

          {/* Table Column Filters */}
          <div className={viewDataStyles.filterCategory}>
            <h4>सामानहरूको फिल्टरहरू</h4>
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>खरिद आदेश / हस्तान्तरण फारम नं.</label>
                <input
                  type="text"
                  value={filters.purchaseOrderNumber || ''}
                  onChange={(e) => handleFilterChange('purchaseOrderNumber', e.target.value)}
                  placeholder="खरिद आदेश फारम नं."
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>जिन्सी वर्गीकरण संकेत नं.</label>
                <input
                  type="text"
                  value={filters.classificationCode || ''}
                  onChange={(e) => handleFilterChange('classificationCode', e.target.value)}
                  placeholder="वर्गीकरण संकेत नं."
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>जिन्सी खाता पाना नं.</label>
                <input
                  type="text"
                  value={filters.ledgerPageNumber || ''}
                  onChange={(e) => handleFilterChange('ledgerPageNumber', e.target.value)}
                  placeholder="खाता पाना नं."
                />
              </div>
            </div>
            
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>सामानको नाम</label>
                <input
                  type="text"
                  value={filters.itemName || ''}
                  onChange={(e) => handleFilterChange('itemName', e.target.value)}
                  placeholder="सामानको नाम"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>स्पेसिफिकेशन</label>
                <input
                  type="text"
                  value={filters.specification || ''}
                  onChange={(e) => handleFilterChange('specification', e.target.value)}
                  placeholder="स्पेसिफिकेशन"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>सामानको पहिचान नं.</label>
                <input
                  type="text"
                  value={filters.itemIdentificationNumber || ''}
                  onChange={(e) => handleFilterChange('itemIdentificationNumber', e.target.value)}
                  placeholder="पहिचान नं."
                />
              </div>
            </div>
            
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>मोडल नं.</label>
                <input
                  type="text"
                  value={filters.modelNumber || ''}
                  onChange={(e) => handleFilterChange('modelNumber', e.target.value)}
                  placeholder="मोडल नं."
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>मूल्य (बिल बिजक अनुसार)</label>
                <input
                  type="text"
                  value={filters.rate || ''}
                  onChange={(e) => handleFilterChange('rate', e.target.value)}
                  placeholder="मूल्य"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>अन्य खर्च</label>
                <input
                  type="text"
                  value={filters.otherExpenses || ''}
                  onChange={(e) => handleFilterChange('otherExpenses', e.target.value)}
                  placeholder="अन्य खर्च"
                />
              </div>
            </div>
            
            <div className={viewDataStyles.filterRow}>
              <div className={viewDataStyles.filterGroup}>
                <label>अन्य खर्च समेत जम्मा रकम</label>
                <input
                  type="text"
                  value={filters.totalWithOtherExpenses || ''}
                  onChange={(e) => handleFilterChange('totalWithOtherExpenses', e.target.value)}
                  placeholder="जम्मा रकम"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <label>कैफियत</label>
                <input
                  type="text"
                  value={filters.remarks || ''}
                  onChange={(e) => handleFilterChange('remarks', e.target.value)}
                  placeholder="कैफियत"
                />
              </div>
              <div className={viewDataStyles.filterGroup}>
                <div className={viewDataStyles.filterStats}>
                  <span>फिल्टर गरिएका: {filteredRows.length}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {viewDataLoading ? (
        <div className={viewDataStyles.loadingContainer}>
          <p>डाटा लोड गर्दै...</p>
        </div>
      ) : (
        <>
          {/* Summary Information */}
          <div className={viewDataStyles.summaryContainer}>
            <div className={viewDataStyles.summaryItem}>
              <span className={viewDataStyles.summaryLabel}>कुल फारमहरू:</span>
              <span className={viewDataStyles.summaryValue}>{viewDataForms.length}</span>
            </div>
            <div className={viewDataStyles.summaryItem}>
              <span className={viewDataStyles.summaryLabel}>कुल सामानहरू:</span>
              <span className={viewDataStyles.summaryValue}>{filteredRows.length}</span>
            </div>
            <div className={viewDataStyles.summaryItem}>
              <span className={viewDataStyles.summaryLabel}>देखाइएका सामानहरू:</span>
              <span className={viewDataStyles.summaryValue}>{paginatedRows.length}</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className={viewDataStyles.actionButtons}>
            <button
              onClick={() => window.location.reload()}
              className={viewDataStyles.actionButton}
              title="Refresh Data"
            >
              🔄 Refresh
            </button>
            <button
              onClick={() => {
                // Create print-friendly content with styling
                const printContent = `
                  <html>
                    <head>
                      <meta charset="utf-8">
                      <title>सामानहरूको सारांश</title>
                      <style>
                        @media print {
                          body { 
                            font-family: 'Noto Sans Devanagari', Arial, sans-serif; 
                            margin: 0; 
                            padding: 20px;
                            background: white;
                          }
                          table { 
                            width: 100%; 
                            border-collapse: collapse; 
                            margin: 20px 0; 
                            font-size: 11px;
                            page-break-inside: auto;
                          }
                          th, td { 
                            border: 1px solid #000; 
                            padding: 6px; 
                            text-align: center; 
                            vertical-align: middle;
                            page-break-inside: avoid;
                          }
                          th { 
                            background-color: #2c3e50 !important; 
                            color: white !important; 
                            font-weight: bold;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                          }
                          th.sub-header { 
                            background-color: #34495e !important; 
                            color: white !important; 
                            font-weight: bold;
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                          }
                          tr:nth-child(even) { 
                            background-color: #f8f9fa !important; 
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                          }
                          tr:nth-child(odd) { 
                            background-color: #ffffff !important; 
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                          }
                          .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            padding: 10px;
                            background: #f5f7fa;
                            border: 2px solid #2c3e50;
                            border-radius: 8px;
                          }
                          .print-info {
                            text-align: right;
                            margin-bottom: 20px;
                            font-size: 12px;
                            color: #666;
                          }
                          @page {
                            size: A4 landscape;
                            margin: 1cm;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      <div class="print-header">
                        <h1>सामानहरूको सारांश</h1>
                        <p>Form 403 - View Data Report</p>
                      </div>
                      <div class="print-info">
                        <p>Generated on: ${new Date().toLocaleString('ne-NP')}</p>
                        <p>Total Items: ${filteredRows.length}</p>
                      </div>
                      <table>
                        <thead>
                          <tr>
                            <th rowspan="2">क्र.सं.</th>
                            <th rowspan="2">खरिद आदेश / हस्तान्तरण फारम नं.</th>
                            <th rowspan="2">जिन्सी वर्गीकरण संकेत नं.</th>
                            <th rowspan="2">जिन्सी खाता पाना नं.</th>
                            <th rowspan="2">सामानको नाम</th>
                            <th rowspan="2">स्पेसिफिकेशन</th>
                            <th rowspan="2">सामानको पहिचान नं.</th>
                            <th rowspan="2">मोडल नं.</th>
                            <th colspan="6">मूल्य (बिल बिजक अनुसार)</th>
                            <th rowspan="2">अन्य खर्च</th>
                            <th rowspan="2">अन्य खर्च समेत जम्मा रकम</th>
                            <th rowspan="2">कैफियत</th>
                          </tr>
                          <tr>
                            <th class="sub-header">इकाई</th>
                            <th class="sub-header">परिमाण</th>
                            <th class="sub-header">दर</th>
                            <th class="sub-header">जम्मा मु.अ.कर बाहेक</th>
                            <th class="sub-header">मु.अ.कर</th>
                            <th class="sub-header">सामानको जम्मा मूल्य</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${filteredRows.map((row, index) => `
                            <tr>
                              <td>${((currentPage - 1) * itemsPerPage) + index + 1}</td>
                              <td>${row.purchase_order_number || 'N/A'}</td>
                              <td>${row.classification_code || 'N/A'}</td>
                              <td>${row.ledger_page_number || 'N/A'}</td>
                              <td>${row.item_name || 'N/A'}</td>
                              <td>${row.specification || 'N/A'}</td>
                              <td>${row.item_identification_number || 'N/A'}</td>
                              <td>${row.model_number || 'N/A'}</td>
                              <td>${row.unit || 'N/A'}</td>
                              <td>${row.quantity || 'N/A'}</td>
                              <td>${row.rate || 'N/A'}</td>
                              <td>${row.total_excluding_vat || 'N/A'}</td>
                              <td>${row.vat || 'N/A'}</td>
                              <td>${row.total_item_value || 'N/A'}</td>
                              <td>${row.other_expenses || 'N/A'}</td>
                              <td>${row.total_with_other_expenses || 'N/A'}</td>
                              <td>${row.remarks || 'N/A'}</td>
                            </tr>
                          `).join('')}
                        </tbody>
                      </table>
                    </body>
                  </html>
                `;

                // Create a new window for printing
                const printWindow = window.open('', '_blank');
                printWindow.document.write(printContent);
                printWindow.document.close();
                
                // Wait for content to load then print
                printWindow.onload = function() {
                  printWindow.print();
                  printWindow.close();
                };
              }}
              className={viewDataStyles.actionButton}
              title="Print Report"
            >
              🖨️ Print Report
            </button>
            <button
              onClick={() => exportToExcel()}
              className={viewDataStyles.actionButton}
              title="Export to Excel"
            >
              📊 Export Excel
            </button>
          </div>

          {/* Items Summary Table */}
          <div className={viewDataStyles.tableContainer}>
            <h3>सामानहरूको सारांश</h3>
            <table className={viewDataStyles.table}>
              <thead>
                <tr>
                  <th rowSpan="2">क्र.सं.</th>
                  <th rowSpan="2">खरिद आदेश / हस्तान्तरण फारम नं.</th>
                  <th rowSpan="2">जिन्सी वर्गीकरण संकेत नं.</th>
                  <th rowSpan="2">जिन्सी खाता पाना नं.</th>
                  <th rowSpan="2">सामानको नाम</th>
                  <th rowSpan="2">स्पेसिफिकेशन</th>
                  <th rowSpan="2">सामानको पहिचान नं.</th>
                  <th rowSpan="2">मोडल नं.</th>
                  <th colSpan="6">मूल्य (बिल बिजक अनुसार)</th>
                  <th rowSpan="2">अन्य खर्च</th>
                  <th rowSpan="2">अन्य खर्च समेत जम्मा रकम</th>
                  <th rowSpan="2">कैफियत</th>
                </tr>
                <tr>
                  <th>इकाई</th>
                  <th>परिमाण</th>
                  <th>दर</th>
                  <th>जम्मा मु.अ.कर बाहेक</th>
                  <th>मु.अ.कर</th>
                  <th>सामानको जम्मा मूल्य</th>
                </tr>
                <tr>
                  <td>१</td>
                  <td>२</td>
                  <td>३</td>
                  <td>४</td>
                  <td>५</td>
                  <td>६</td>
                  <td>७</td>
                  <td>८</td>
                  <td>९</td>
                  <td>१०</td>
                  <td>११</td>
                  <td>१२</td>
                  <td>१३</td>
                  <td>१४</td>
                  <td>१५</td>
                  <td>१६</td>
                  <td>१७</td>
                </tr>
              </thead>
              <tbody>
                {paginatedRows.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>{((currentPage - 1) * itemsPerPage) + index + 1}</td>
                    <td>{row.purchase_order_number || ''}</td>
                    <td>{row.classification_code || ''}</td>
                    <td>{row.ledger_page_number || ''}</td>
                    <td>{row.item_name || ''}</td>
                    <td>{row.specification || ''}</td>
                    <td>{row.item_identification_number || ''}</td>
                    <td>{row.model_number || ''}</td>
                    <td>{row.unit || ''}</td>
                    <td>{row.quantity || ''}</td>
                    <td>{row.rate || ''}</td>
                    <td>{row.total_excluding_vat || ''}</td>
                    <td>{row.vat || ''}</td>
                    <td>{row.total_item_value || ''}</td>
                    <td>{row.other_expenses || ''}</td>
                    <td>{row.total_with_other_expenses || ''}</td>
                    <td>{row.remarks || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className={viewDataStyles.paginationContainer}>
            <div className={viewDataStyles.paginationInfo}>
              <span>पृष्ठ {currentPage} को {filteredRows.length === 0 ? 0 : totalPages}</span>
              <select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className={viewDataStyles.itemsPerPageSelect}
              >
                <option value={100}>100 प्रति पृष्ठ</option>
                <option value={200}>200 प्रति पृष्ठ</option>
                <option value={300}>300 प्रति पृष्ठ</option>
                <option value={500}>500 प्रति पृष्ठ</option>
              </select>
            </div>
            
            <div className={viewDataStyles.paginationButtons}>
              <button
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
                className={viewDataStyles.paginationButton}
              >
                पहिलो
              </button>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={viewDataStyles.paginationButton}
              >
                अघिल्लो
              </button>
              
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                const page = Math.max(1, Math.min(totalPages - 4, currentPage - 2)) + i;
                return (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`${viewDataStyles.paginationButton} ${currentPage === page ? viewDataStyles.activePage : ''}`}
                  >
                    {page}
                  </button>
                );
              })}
              
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={viewDataStyles.paginationButton}
              >
                अर्को
              </button>
              <button
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
                className={viewDataStyles.paginationButton}
              >
                अन्तिम
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewData;
